import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { BsModalRef } from 'ngx-bootstrap';
import { SweetMessage } from '../../../config/sweet-message';
import { Validation } from '../../../config/validation';
import { NivelHotel } from '../../../models/nivel-hotel';
import { NivelHotelService } from '../../../services/nivel-hotel.service';
import { SessionService } from '../../../services/session.service';

@Component({
  selector: 'app-nivel-hotel-edit-modal',
  templateUrl: './nivel-hotel-edit-modal.component.html',
  styleUrls: ['./nivel-hotel-edit-modal.component.css'],
  providers: [
    NivelHotelService,
  ],
})
export class NivelHotelEditModalComponent implements OnInit {
	@Input() nivel_hotel_id: String;
	@Output() sendNivelHotel = new EventEmitter();
	public title: String;
	public nivelHotel: NivelHotel;
	public msg: SweetMessage;
	myForm: FormGroup;
	public vl: Validation;
	public loading = false;
	constructor(
		public bsModalRef: BsModalRef,
		private nivelHotelService: NivelHotelService,
		private storage: AsyncLocalStorage,
		private ss: SessionService,
		public fb: FormBuilder,
	) {
		this.title = "Guardar";
			
	}

	ngOnInit() {
		//Inicializar Formulario
		this.onForm();
		//Inicializacion de Objectos
		this.msg = new SweetMessage();
		//Inicializacion de Objecto de validacion
		this.vl = new Validation();
		//Inicializacion de objecto Banco
		this.nivelHotel = new NivelHotel();
			
		this.getAsientoById();
	}

	getAsientoById(){    
		return new Promise ( (resolve, reject) => {
		this.nivelHotelService.getById(this.nivel_hotel_id).subscribe(
			res => {
			
			this.nivelHotel = res;
			this.setValueForm();
			resolve();
			},
			err => {
			reject();
			}
		);
		});   
	}



 	onForm() {
		this.myForm = this.fb.group({
			nombre: ['', [Validators.required,
			Validators.pattern(/[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ\s]*/)]],
		});
	}

	setValueForm() {
		this.myForm.setValue({
			nombre: this.nivelHotel.nombre
		});
	}
	setValueEntity(){
		this.nivelHotel.nombre = this.myForm.controls['nombre'].value;
		this.nivelHotel.usuario_id = this.ss.getData('usuario_id');
	}

	validErrorForm(campo){
		return this.vl.validErrorForm(campo,this.myForm);
	}

	validTypeMsgForm(nombre,campo){
		return this.vl.validTypeMsgForm(nombre,campo,this.myForm);
  	}
  
	onSubmit(){
		this.setValueEntity();
		this.msg.showMessage('delete-confirm-message', "¿Está seguro de confirmar la modificación?").then(
			res => {
				this.loading = true;
				this.nivelHotelService.update(this.nivelHotel).subscribe(
					res => {
						this.msg.showMessage('success-message', 'Se ha procesado correctamente' );
						this.sendNivelHotel.emit(res.data);
						this.loading = false;
					},
					err => { 
						this.loading = false;
						this.msg.showMessage('error-message', err);
					}
				);
			}
		);
	}


}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/nivel-hotel-edit-modal/nivel-hotel-edit-modal.component.ts